'use client';

import { type ReactNode } from 'react';
import { automationId } from '@terra/shared-utils';
import { HeadingPage } from '../../components/typography';
import { Tooltip } from '../../components/tooltip';

type PageHeaderTitleProps = {
  title: ReactNode;
  titleTestId?: string;
};

const resolveTitleText = (title: ReactNode): string | undefined => {
  if (typeof title === 'string' || typeof title === 'number') {
    return String(title);
  }

  return undefined;
};

export function PageHeaderTitle({ title, titleTestId }: PageHeaderTitleProps) {
  const titleText = resolveTitleText(title);

  const heading = (
    <HeadingPage
      color="fg.neutral.default"
      whiteSpace="nowrap"
      textOverflow="ellipsis"
      overflow="hidden"
      w="full"
      truncate
      {...(titleTestId ? automationId(titleTestId) : {})}
    >
      {title}
    </HeadingPage>
  );

  if (!titleText) {
    return heading;
  }

  return <Tooltip title={titleText}>{heading}</Tooltip>;
}
